/* cl-pdp.js — comportamento do buybox copiado do tema dele (snippets cl-pdp-*.liquid, build_pdp.py).

   - galeria: fade no desktop (>=768px, "slideshow" dele) e carrossel centrado com volta no mobile
     ("carousel" dele); miniaturas, setas, arrasto/swipe; a foto da variante entra ao trocar a opcao
   - opcoes (botoes/swatches): acham a variante, escrevem o id no form NATIVO do Shrine
     (buy_buttons, form="{{ product_form_id }}"), atualizam preco, riscado, legenda, esgotado e a URL
   - quantidade -/+ e o preco no botao (preco x quantidade, como o dele)
   - acordeoes e o modal "GUIDE DES TAILLES" (micromodal dele) */
(function () {
  'use strict';

  function fmt(cents, f) {
    f = f || 'R$ {{amount_with_comma_separator}}';
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    function g(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return g(v[0], '.') + ',' + v[1];
      if (k === 'amount_no_decimals') return g(String(Math.round(cents / 100)), ',');
      if (k === 'amount_no_decimals_with_comma_separator') return g(String(Math.round(cents / 100)), '.');
      return g(v[0], ',') + '.' + v[1];
    });
  }

  /* ------------------------------------------------------------- galeria --- */
  function Gallery(root) {
    var vp = root.querySelector('.flickity-viewport');
    if (!vp) return null;
    var slider = vp.querySelector('.flickity-slider');
    var cells = [].slice.call(slider.children).filter(function (c) { return c.hasAttribute('data-media-slide'); });
    var thumbs = [].slice.call(root.querySelectorAll('[data-media-select]'));
    var idx = 0, mode = '', n = cells.length;
    if (!n) return null;
    // abre na foto da variante selecionada (data-initial-variant-media-id do tema dele)
    var im = root.getAttribute('data-cl-initial-media');
    cells.forEach(function (c, i) { if (im && c.getAttribute('data-media-id') === im) idx = i; });
    var grid = vp.closest('[data-product-slideshow]');
    var mstyle = (grid && grid.getAttribute('data-slideshow-mobile-style')) || 'carousel';
    var dots = null;
    if (mstyle === 'slideshow' && grid && n > 1) {
      // "slideshow" no mobile: o flickity dele poe os dots (pilula) sobre a foto
      dots = document.createElement('div');
      dots.className = 'flickity-page-dots cl-mobile-dots';
      for (var di = 0; di < n; di++) {
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'flickity-page-dot'; bt.textContent = 'View slide ' + (di + 1);
        (function (k) { bt.addEventListener('click', function (e) { e.preventDefault(); go(k); }); })(di);
        dots.appendChild(bt);
      }
      grid.appendChild(dots);
      grid.classList.add('product__mobile--slideshow');
    }

    function isDesk() { return window.matchMedia('(min-width: 768px)').matches; }
    function layout(animate) {
      mode = isDesk() ? 'fade' : 'carousel';
      root.setAttribute('data-cl-mode', mode);
      if (dots) {
        dots.style.display = isDesk() ? 'none' : '';
        [].forEach.call(dots.children, function (d, i) { d.classList.toggle('is-selected', i === idx); if (i === idx) d.setAttribute('aria-current', 'step'); else d.removeAttribute('aria-current'); });
      }
      // como o flickity dele: no mobile a galeria NAO e fade (sem is-fade), no desktop e
      var fl = vp.closest('.flickity-enabled');
      if (fl) fl.classList.toggle('is-fade', mode === 'fade');
      var W = vp.clientWidth;
      var cw = cells[0].getBoundingClientRect().width || W;
      var hMax = 0;
      cells.forEach(function (c) { hMax = Math.max(hMax, c.offsetHeight); });
      if (mode === 'fade') {
        vp.style.height = (cells[idx].offsetHeight || hMax) + 'px';
        cells.forEach(function (c, i) {
          c.style.transition = animate ? '' : 'none';
          c.style.transform = 'translate3d(' + ((W - cw) / 2) + 'px,0,0)';
          c.style.opacity = i === idx ? '1' : '0';
          c.style.zIndex = i === idx ? '1' : '0';
          c.style.pointerEvents = i === idx ? '' : 'none';
          c.classList.toggle('is-selected', i === idx);
          c.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
        });
      } else {
        // como o flickity dele (adaptive): altura = a da celula selecionada, nao a maior
        vp.style.height = (cells[idx].getBoundingClientRect().height || hMax) + 'px';
        var x0 = (W - cw) / 2;
        // passo do flickity = largura + margem da celula (o tema dele poe margin-right: 10px)
        var c0 = getComputedStyle(cells[0]);
        var step = cw + (parseFloat(c0.marginLeft) || 0) + (parseFloat(c0.marginRight) || 0);
        cells.forEach(function (c, i) {
          var d = i - idx;
          if (n > 2) { if (d > n / 2) d -= n; if (d < -n / 2) d += n; }
          var prev = c._d;
          c._d = d;
          var jump = prev !== undefined && Math.abs(prev - d) > 1;
          c.style.transition = (animate && !jump) ? 'transform .35s ease' : 'none';
          c.style.transform = 'translate3d(' + (x0 + d * step) + 'px,0,0)';
          c.style.opacity = '1'; c.style.zIndex = ''; c.style.pointerEvents = '';
          c.classList.toggle('is-selected', i === idx);
          c.setAttribute('aria-hidden', i === idx ? 'false' : 'true');
        });
      }
      // setas oi-gnav: o JS dele poe --OI-GNAV-TOP = meio da galeria (o extract congelou o valor do desktop)
      var gw = vp.closest('[data-oi-gallery]');
      if (gw) gw.style.setProperty('--OI-GNAV-TOP', (vp.getBoundingClientRect().top - gw.getBoundingClientRect().top + vp.offsetHeight / 2) + 'px');
      thumbs.forEach(function (t, i) { t.classList.toggle('is-activated', i === idx); });
      var at = thumbs[idx];
      if (at && at.parentElement && at.parentElement.scrollWidth > at.parentElement.clientWidth) {
        var p = at.parentElement, l = at.offsetLeft - p.offsetLeft;
        if (l < p.scrollLeft || l + at.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollTo({ left: l - p.clientWidth / 2 + at.offsetWidth / 2, behavior: animate ? 'smooth' : 'auto' });
      }
    }
    function go(i, animate) { idx = ((i % n) + n) % n; layout(animate !== false); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function (e) { e.preventDefault(); go(i); }); });
    var pv = root.querySelector('[data-thumbs-arrow-prev]'), nx = root.querySelector('[data-thumbs-arrow-next]');
    pv && pv.addEventListener('click', function (e) { e.preventDefault(); go(idx - 1); });
    nx && nx.addEventListener('click', function (e) { e.preventDefault(); go(idx + 1); });
    root.querySelectorAll('.flickity-prev-next-button.previous, [data-cl-prev]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(idx - 1); }); });
    root.querySelectorAll('.flickity-prev-next-button.next, [data-cl-next]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); go(idx + 1); }); });
    // arrasto / swipe
    var sx = null, sy = null, moved = false;
    vp.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; });
    vp.addEventListener('pointermove', function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 8) moved = true; });
    vp.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
    });
    vp.addEventListener('pointercancel', function () { sx = null; });
    var tx = null, ty = null;
    vp.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    vp.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var t = e.changedTouches[0], dx = t.clientX - tx, dy = t.clientY - ty; tx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { sx = null; go(idx + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { layout(false); }, 80); });
    cells.forEach(function (c) { var im = c.querySelector('img'); if (im && !im.complete) im.addEventListener('load', function () { layout(false); }, { once: true }); });
    layout(false);
    return {
      toMedia: function (id) {
        for (var i = 0; i < n; i++) if (cells[i].getAttribute('data-media-id') === String(id)) { go(i); return; }
      }, relayout: function () { layout(false); }
    };
  }

  /* ------------------------------------------------------------ variantes --- */
  function Buybox(root, gal) {
    var js = root.parentElement.querySelector('script[data-cl-pdp-json]') || document.querySelector('script[data-cl-pdp-json]');
    if (!js) return;
    var data; try { data = JSON.parse(js.textContent); } catch (e) { return; }
    var host = root.closest('[data-cl-pdp-host]');
    var formId = host && host.getAttribute('data-form-id');
    var form = formId && document.getElementById(formId);
    var qtyIn = root.querySelector('.quantity__input, .clx-quantity__input');
    var atc = root.querySelector('[data-cl-atc]');
    var booted = false;

    function selected() {
      var vals = [];
      root.querySelectorAll('input[data-cl-opt]:checked').forEach(function (i) { vals[+i.getAttribute('data-cl-opt') - 1] = i.value; });
      return vals;
    }
    function find(vals) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] === undefined || vals[i] === o; }); })[0];
    }
    function q() { return Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1); }
    function soldOut(vals) {
      root.querySelectorAll('input[data-cl-opt]').forEach(function (inp) {
        var p = +inp.getAttribute('data-cl-opt') - 1;
        var ok = data.variants.some(function (v) {
          if (!v.available || v.options[p] !== inp.value) return false;
          for (var j = 0; j < v.options.length; j++) if (j !== p && vals[j] !== undefined && v.options[j] !== vals[j]) return false;
          return true;
        });
        inp.classList.toggle('sold-out', !ok);
        inp.classList.toggle('unavailable', !ok);
      });
    }
    function apply() {
      var vals = selected(), v = find(vals);
      soldOut(vals);
      root.querySelectorAll('[data-swapper-wrapper]').forEach(function (w) {
        var c = w.querySelector('input[data-cl-opt]:checked'), t = w.querySelector('[data-option-value]');
        if (c && t) t.textContent = c.value;
      });
      if (!v) return;
      if (form) {
        var idIn = form.querySelector('input[name="id"]');
        if (idIn && idIn.value !== String(v.id)) { idIn.value = v.id; idIn.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      var pr = root.querySelector('[data-product-price] .ht-money, [data-product-price]');
      if (pr) pr.textContent = fmt(v.price, data.money);
      var cp = root.querySelector('[data-compare-price]');
      if (cp) {
        cp.style.display = v.compare > v.price ? '' : 'none';
        var cm = cp.querySelector('.ht-money') || cp; cm.textContent = fmt(v.compare, data.money);
      }
      var bp = root.querySelector('[data-button-price]');
      if (bp) bp.textContent = fmt(v.price * q(), data.money);
      if (atc) {
        atc.disabled = !v.available;
        var tx = atc.querySelector('[data-add-to-cart-text]');
        if (tx) tx.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (booted) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        if (v.media && gal) gal.toMedia(v.media);
      }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input[data-cl-opt]')) apply(); });
    // quantidade
    root.querySelectorAll('.quantity__button, .clx-quantity__button').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!qtyIn) return;
        qtyIn.value = Math.max(1, q() + ((b.classList.contains('quantity__button--minus') || b.classList.contains('clx-quantity__button--minus')) ? -1 : 1));
        qtyIn.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qtyIn) qtyIn.addEventListener('change', function () {
      var m = root.querySelector('.quantity__button--minus, .clx-quantity__button--minus'); if (m) m.disabled = q() <= 1;
      apply();
    });
    // a variante da URL (?variant=) entra no load sem mexer na galeria (o tema ja abriu na foto certa)
    try {
      var want = new URL(location.href).searchParams.get('variant');
      var wv = want && data.variants.filter(function (v) { return String(v.id) === want; })[0];
      if (wv) wv.options.forEach(function (o, i) {
        root.querySelectorAll('input[data-cl-opt="' + (i + 1) + '"]').forEach(function (inp) { inp.checked = inp.value === o; });
      });
    } catch (e) {}
    apply();
    booted = true;
  }

  /* --------------------------------------------- kit (replica do Kaching Bundles) --- */
  function Kit(root) {
    var box = root.querySelector('[data-cl-kit]');
    var kj = root.parentElement.querySelector('script[data-cl-kit-json]');
    var pj = root.parentElement.querySelector('script[data-cl-pdp-json]');
    if (!box || !kj || !pj) return;
    var kit, data;
    try { kit = JSON.parse(kj.textContent); data = JSON.parse(pj.textContent); } catch (e) { return; }
    var names = (data.optionNames || []).map(function (n) { return String(n).toLowerCase(); });
    var bars = [].slice.call(box.querySelectorAll('.kaching-bundles__bar'));
    var host = root.closest('[data-cl-pdp-host]');
    var formId = host && host.getAttribute('data-form-id');
    var atc = root.querySelector('[data-cl-atc]');
    var kf = formId && document.getElementById(formId); if (kf) kf.setAttribute('data-cl-kit-form', '');

    function values(pos) {
      var seen = {}, out = [];
      data.variants.forEach(function (v) { var x = v.options[pos]; if (x != null && !seen[x]) { seen[x] = 1; out.push(x); } });
      return out;
    }
    function rowVariant(row) {
      var want = [];
      row.querySelectorAll('[data-name]').forEach(function (el) {
        var i = names.indexOf(String(el.getAttribute('data-name')).toLowerCase());
        if (i >= 0) want[i] = el.getAttribute('data-value');
      });
      var exact = data.variants.filter(function (v) { return v.options.every(function (o, i) { return want[i] === undefined || want[i] === o; }); })[0];
      return exact;
    }
    function selectedBar() { return bars.filter(function (b) { return b.classList.contains('kaching-bundles__bar--selected'); })[0] || bars[0]; }
    function barIndex(b) { return bars.indexOf(b); }
    function money(c) { return fmt(c, data.money); }
    function rowsOf(b) { return [].slice.call(b.querySelectorAll('.kaching-bundles__bar-variant')); }
    // total da barra do kit com q pecas: o desconto e UM percentual sobre {pecas + 2 brindes}, entao o
    // carrinho cobra (q*unit + brindes) * fator — o widget mostra isso (em q = qty e o preco do kit dele)
    function kitTotal(cfg, q) {
      if (!cfg.total) return 0;
      if (!kit.unit || q === cfg.qty) return cfg.total;
      var g = kit.giftTotal || 0;
      return Math.round((q * kit.unit + g) * cfg.total / (cfg.qty * kit.unit + g));
    }
    function refreshPrice() {
      var b = selectedBar(), i = barIndex(b), cfg = kit.bars[i] || {};
      var row = b.querySelector('.kaching-bundles__bar-variant');
      var v = row ? rowVariant(row) : null;
      var q = cfg.total ? rowsOf(b).length || cfg.qty : cfg.qty;
      var total = cfg.total ? kitTotal(cfg, q) : (v ? v.price : 0) * (cfg.qty || 1);
      var bp = root.querySelector('[data-button-price]');
      if (bp && total) bp.textContent = money(total);
      if (cfg.total) {
        var kp = b.querySelector('.kaching-bundles__bar-price .ht-money'); if (kp) kp.textContent = money(total);
        var kf2 = b.querySelector('.kaching-bundles__bar-full-price .ht-money'); if (kf2 && kit.unitFull) kf2.textContent = money(kit.unitFull * q);
      }
      if (i > 0 && v) {
        var pe = b.querySelector('.kaching-bundles__bar-price .ht-money'); if (pe) pe.textContent = money(v.price);
      }
      if (atc) {
        var ok = [].slice.call(b.querySelectorAll('.kaching-bundles__bar-variant')).every(function (r) { var x = rowVariant(r); return x && x.available; });
        atc.disabled = !ok;
      }
    }
    function availability(row) {
      // tamanho sem estoque para a cor escolhida fica "indisponivel" (como o app dele)
      var ci = names.indexOf('couleur'); if (ci < 0) ci = names.indexOf('color');
      var col = ci >= 0 ? (row.querySelector('[data-name][data-value]') || {}).getAttribute : null;
      var colorEl = row.querySelector('.kaching-bundles__swatch-dropdown');
      var cv = colorEl ? colorEl.getAttribute('data-value') : null;
      row.querySelectorAll('select.kaching-bundles__bar-variant-select').forEach(function (sel) {
        var si = names.indexOf(String(sel.getAttribute('data-name')).toLowerCase());
        [].forEach.call(sel.options, function (o) {
          var ok = data.variants.some(function (v) { return v.available && v.options[si] === o.value && (ci < 0 || cv == null || v.options[ci] === cv); });
          o.disabled = !ok;
          o.textContent = o.value + (ok ? '' : ' - indisponible');
        });
        if (sel.selectedOptions[0] && sel.selectedOptions[0].disabled) {
          var first = [].filter.call(sel.options, function (o) { return !o.disabled; })[0];
          if (first) { sel.value = first.value; sel.setAttribute('data-value', first.value); }
        }
      });
    }
    // cor: o combobox desenhado do app ganha um <select> nativo transparente por cima
    function bindColor(dd) {
      var ci = names.indexOf(String(dd.getAttribute('data-name')).toLowerCase());
      if (ci < 0) return;
      var sel = document.createElement('select');
      sel.className = 'cl-kit-native';
      sel.setAttribute('aria-label', dd.getAttribute('data-name'));
      values(ci).forEach(function (val) {
        var o = document.createElement('option'); o.value = o.textContent = val;
        if (val === dd.getAttribute('data-value')) o.selected = true;
        sel.appendChild(o);
      });
      dd.style.position = 'relative';
      dd.appendChild(sel);
      sel.addEventListener('change', function () {
        dd.setAttribute('data-value', sel.value);
        var name = dd.querySelector('[role="combobox"] > span:not(.kaching-bundles__swatch)') || dd.querySelector('[role="combobox"] span');
        if (name) name.textContent = sel.value;
        var sw = dd.querySelector('.kaching-bundles__swatch');
        var c = kit.colors && kit.colors[sel.value];
        if (sw && c) { sw.style.setProperty('--kaching-swatch-color', c); sw.style.setProperty('--kaching-swatch-border-color', c); }
        var row = dd.closest('.kaching-bundles__bar-variant'); if (row) availability(row);
        refreshPrice();
      });
      sel.addEventListener('click', function (e) { e.stopPropagation(); });
    }
    function bindSize(s) {
      s.addEventListener('change', function () { s.setAttribute('data-value', s.value); refreshPrice(); });
      s.addEventListener('click', function (e) { e.stopPropagation(); });
    }
    box.querySelectorAll('.kaching-bundles__swatch-dropdown').forEach(bindColor);
    box.querySelectorAll('select.kaching-bundles__bar-variant-select').forEach(bindSize);
    // seletor "- N +" do app na barra do kit: minimo = pecas do kit; "+" acrescenta uma linha #N+1
    // (copia da ultima), "-" tira a ultima
    bars.forEach(function (b, bi) {
      var qs = b.querySelector('.kaching-bundles__quantity-selector');
      var cfg = kit.bars[bi] || {};
      if (!qs || !cfg.qty) return;
      var btns = qs.querySelectorAll('.kaching-bundles__quantity-selector__button');
      var inp = qs.querySelector('input');
      var min = cfg.qty;
      function setQ(q) {
        q = Math.max(min, Math.min(99, parseInt(q, 10) || min));
        var wraps = [].slice.call(b.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper'));
        var last = wraps[wraps.length - 1];
        while (last && wraps.length < q) {
          var c = last.cloneNode(true);
          c.querySelectorAll('.cl-kit-native').forEach(function (x) { x.remove(); });
          var num = c.querySelectorAll('.kaching-bundles__bar-variant-number span'); if (num.length) num[num.length - 1].textContent = String(wraps.length + 1);
          last.parentNode.insertBefore(c, last.nextSibling);
          var ls = last.querySelector('select.kaching-bundles__bar-variant-select'), cs = c.querySelector('select.kaching-bundles__bar-variant-select');
          if (ls && cs) cs.value = ls.value;
          c.querySelectorAll('.kaching-bundles__swatch-dropdown').forEach(bindColor);
          c.querySelectorAll('select.kaching-bundles__bar-variant-select').forEach(bindSize);
          c.querySelectorAll('.kaching-bundles__bar-variant').forEach(availability);
          wraps.push(c); last = c;
        }
        while (wraps.length > q) wraps.pop().remove();
        if (inp) inp.value = q;
        if (btns[0]) { btns[0].classList.toggle('kaching-bundles__quantity-selector__button--disabled', q <= min); btns[0].setAttribute('aria-disabled', q <= min ? 'true' : 'false'); }
        refreshPrice();
      }
      if (inp) {
        inp.value = min;
        inp.addEventListener('click', function (e) { e.stopPropagation(); });
        inp.addEventListener('change', function () { setQ(inp.value); });
      }
      if (btns[0]) btns[0].addEventListener('click', function (e) { e.stopPropagation(); setQ((parseInt(inp && inp.value, 10) || min) - 1); });
      if (btns[1]) btns[1].addEventListener('click', function (e) { e.stopPropagation(); setQ((parseInt(inp && inp.value, 10) || min) + 1); });
    });
    bars.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        bars.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('kaching-bundles__bar--selected', on);
          var r = x.querySelector('input[type="radio"]'); if (r) r.checked = on;
        });
        refreshPrice();
      });
    });
    box.querySelectorAll('.kaching-bundles__bar-variant').forEach(availability);
    refreshPrice();
    // ATC: o kit vira N linhas (+ brindes) no carrinho; o form nativo nao e enviado
    // o main.js do Shrine liga um clique DIRETO em todo botao com form="{{ product_form_id }}" e envia o form
    // nativo por fetch: o kit tem que pegar o CLIQUE antes (captura no document) e tambem um submit residual
    function onKit(e) {
      if (e.type === 'click') { if (!atc || !e.target.closest || e.target.closest('[data-cl-atc]') !== atc) return; }
      else if (!formId || e.target.id !== formId) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var b = selectedBar(), i = barIndex(b), cfg = kit.bars[i] || { qty: 1 };
      var title = (b.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
      var lines = {};
      b.querySelectorAll('.kaching-bundles__bar-variant').forEach(function (r) {
        var v = rowVariant(r); if (!v) return;
        lines[v.id] = (lines[v.id] || 0) + 1;
      });
      var items = Object.keys(lines).map(function (id) {
        var it = { id: +id, quantity: lines[id] };
        if (cfg.qty > 1) it.properties = { _cl_kit: title.trim() };
        return it;
      });
      if (cfg.qty > 1) (kit.gifts || []).forEach(function (g) { if (g) items.push({ id: g, quantity: 1, properties: { _cl_kit_gift: '1' } }); });
      if (!items.length) return;
      if (atc) { atc.disabled = true; atc.classList.add('loading'); }
      var p = window.CLKC ? window.CLKC.add(items).then(function () { window.CLKC.open(); })
        : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function () { location.href = '/cart'; });
      p.catch(function (x) { alert(x.message || x); }).then(function () { if (atc) { atc.disabled = false; atc.classList.remove('loading'); } });
    }
    document.addEventListener('click', onKit, true);
    document.addEventListener('submit', onKit, true);
  }

  /* ------------------------- app Kaching Bundles REAL no slot (retrabalho 2026-10-14) --- */
  // o widget e do app (preco/variantes/carrinho sao dele); aqui so o rotulo do botao copiado acompanha a
  // barra escolhida, como o botao do tema dele faz com o app ("AJOUTER AU PANIER • <preco do pack>")
  function AppKit(root) {
    var slot = root.querySelector('[data-cl-app-slot]');
    var bp = root.querySelector('[data-button-price]');
    if (!slot || !bp) return;
    var q = 0;
    function sync() {
      q = 0;
      var b = slot.querySelector('.kaching-bundles__bar--selected');
      var pr = b && b.querySelector('.kaching-bundles__bar-price');
      var t = pr && pr.textContent.trim();
      if (t && bp.textContent !== t) bp.textContent = t;
    }
    new MutationObserver(function () { if (!q) q = requestAnimationFrame(sync); })
      .observe(slot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'], characterData: true });
    // o Buybox reescreve o preco do botao na troca de variante: a barra do app manda
    new MutationObserver(function () { if (!q) q = requestAnimationFrame(sync); }).observe(bp, { childList: true, characterData: true, subtree: true });
    sync();
  }

  /* ------------------------------------------------------ acordeao / modal --- */
  function accordions(root) {
    root.querySelectorAll('button.accordion__title, button.clx-accordion__title').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var body = document.getElementById(b.getAttribute('aria-controls')) || b.parentElement.querySelector('.accordion__body');
        if (!body) return;
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        b.classList.toggle('accordion-is-open', !open);
        if (open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.transition = 'height .3s ease'; body.style.height = '0px'; });
          setTimeout(function () { body.style.display = 'none'; body.style.height = ''; body.style.transition = ''; }, 310);
        } else {
          body.style.display = 'block'; var h = body.scrollHeight; body.style.height = '0px';
          requestAnimationFrame(function () { body.style.transition = 'height .3s ease'; body.style.height = h + 'px'; });
          setTimeout(function () { body.style.height = ''; body.style.transition = ''; }, 310);
        }
      });
    });
  }
  function modals() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-cl-size-open]');
      if (o) {
        e.preventDefault();
        var m = document.getElementById(o.getAttribute('data-cl-size-open'));
        if (!m) return;
        var host = m.closest('.cl-pdp-modal-host');
        if (host && host.parentElement !== document.body) document.body.appendChild(host);
        m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('cl-modal-lock');
        return;
      }
      var c = e.target.closest('.cl-pdp-modal-host [data-micromodal-close]');
      if (c && (c === e.target || c.tagName === 'BUTTON' || e.target === c)) {
        if (c.classList.contains('modal__overlay') && e.target !== c) return;
        var mm = c.closest('.modal'); if (!mm) return;
        mm.classList.remove('is-open'); mm.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('cl-modal-lock');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.cl-pdp-modal-host .modal.is-open').forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
      document.documentElement.classList.remove('cl-modal-lock');
    });
  }

  function init() {
    document.querySelectorAll('[data-cl-pdp]').forEach(function (root) {
      if (root._clpdp) return; root._clpdp = 1;
      var g = Gallery(root);
      Buybox(root, g);
      Kit(root);
      AppKit(root);
      accordions(root);
    });
    modals();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
